/**
 * The answer text its parts render as. Parts whose text is a prefix of
 * another's (or identical) are the same response captured at different points
 * — across multi-message agentic turns, streaming order, or a stream-resume —
 * so only the longest of each prefix family is kept, and the answer renders
 * once instead of duplicating or truncating.
 */
export function joinAnswerText(parts: Array<{ text: string }>): string {
  const kept: Array<string> = []
  for (const text of parts.map((part) => part.text.trim()).filter(Boolean)) {
    const dupIdx = kept.findIndex((k) => k.startsWith(text) || text.startsWith(k))
    if (dupIdx === -1) {
      kept.push(text)
    } else if (text.length > kept[dupIdx].length) {
      kept[dupIdx] = text
    }
  }
  return kept.join('\n\n').trim()
}
